<h2 mat-dialog-title>Recorte de imagen</h2>

<mat-dialog-content>
  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <div class="toolbar">
    <button mat-stroked-button color="primary" type="button" (click)="capture()" [disabled]="capturing || saving">
      {{ capturing ? 'Capturando…' : 'Capturar foto desde báscula' }}
    </button>
    <span class="hint">Haz clic y arrastra para seleccionar la zona a recortar.</span>
  </div>

  <canvas
    #canvas
    width="640"
    height="360"
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp()"
    (mouseleave)="onMouseLeave()"
  ></canvas>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="saving">Guardar</button>
</mat-dialog-actions>

